<template>
  <div>
    <el-dialog
      title="申请材料"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="dialog-box">
        <div class="info-box">
          <div class="info-box-item">
            <div>姓名: {{ Boolean(infoObj) ? infoObj.realName : '--' }}</div>
            <div>民族: {{ infoObj ? infoObj.nation : '--' }}</div>
            <div>班级: {{ infoObj ? infoObj.className : '--' }}</div>
            <div>手机: {{ infoObj ? infoObj.mobile : '--' }}</div>
          </div>
          <div class="info-box-item-right">
            <div v-if="infoObj">
              性别: {{ infoObj.gender===1 ? '男性' : infoObj.gender===2 ?'女性':'未知性别' }}
            </div>
            <div>学院: {{ infoObj ? infoObj.collegeName : '--' }}</div>
            <div>出生年月: {{ infoObj ? getTime(infoObj.birthday) : '' }}
            </div>
            <div>邮箱: {{ infoObj ? infoObj.email : '--' }}</div>
          </div>
          <div style="font-size: 16px">
            <span>银行卡号:</span>
            <div v-if="canInsert || interviewResult === 'PASS'">
              <el-autocomplete
                v-model="bankNo"
                maxlength="60"
                style="width: 100%;margin-top: 5px"
                class="inline-input"
                :fetch-suggestions="querySearch"
                placeholder="请输入银行卡号"
                :popper-append-to-body="false"
                @select="handleSelect"
              />
            </div>
            <div v-else>
              <span v-if="isApplication">{{ infoObj && infoObj.bankNo }}</span>
              <span v-else>
                <span
                  v-if="infoObj && infoObj.bankNoDefault === false"
                  class="warningD"
                >
                  <span>{{ infoObj && infoObj.bankNo }}</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top-start"
                  >
                    <span
                      v-if="infoObj && infoObj.defaultBankNo"
                      slot="content"
                    >不一致,历史账号:{{ infoObj && infoObj.defaultBankNo }}</span>
                    <span
                      v-else
                      slot="content"
                    >暂无历史账号</span>
                    <i class="el-icon-warning" />
                  </el-tooltip>
                </span>
                <span
                  v-if="infoObj && infoObj.bankNoDefault === true"
                  class="successD"
                >
                  <span>{{ infoObj && infoObj.bankNo }}</span>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="与历史账号一致"
                    placement="top-start"
                  >
                    <i class="el-icon-success" />
                  </el-tooltip>
                </span>
              </span>
            </div>
          </div>
          <div style="margin-top: 15px; font-size: 16px">
            银行卡开户行:
            <span v-if="!canInsert">{{ infoObj && infoObj.bankName }}</span>
            <div v-else>
              <el-input
                v-model="bankName"
                maxlength="60"
                placeholder="请输入开户银行"
                style="margin-top: 5px"
              />
            </div>
          </div>
        </div>
        <div class="box-title">
          学习情况(200字以内)
        </div>
        <div class="box-title-detail">
          <el-input
            v-if="isApplication"
            v-model="stuStuation"
            type="textarea"
            maxlength="200"
            :autosize="{ minRows: 4}"
            placeholder="请输入内容"
          />
          <span v-else>{{ applicationData && applicationData.study }}</span>
        </div>
        <div class="box-title">
          工作情况(200字以内)
        </div>
        <div class="box-title-detail">
          <el-input
            v-if="isApplication"
            v-model="workStuation"
            maxlength="200"
            type="textarea"
            :autosize="{ minRows: 4}"
            placeholder="请输入内容"
          />
          <span v-else>{{ applicationData && applicationData.work }}</span>
        </div>
        <div class="box-title">
          经济情况(200字以内)
        </div>
        <div class="box-title-detail">
          <el-input
            v-if="isApplication"
            v-model="economyStuation"
            type="textarea"
            maxlength="200"
            :autosize="{ minRows: 4}"
            placeholder="请输入内容"
          />
          <span v-else>{{ applicationData && applicationData.economic }}</span>
        </div>
        <div class="box-title">
          对申请岗位的认识(200字以内)
        </div>
        <div class="box-title-detail">
          <el-input
            v-if="isApplication"
            v-model="unitKnown"
            type="textarea"
            maxlength="200"
            :autosize="{ minRows: 4}"
            placeholder="请输入内容"
          />
          <span v-else>{{ applicationData && applicationData.cognition }}</span>
        </div>
        <div class="box-title">
          特长和爱好(200字以内)
        </div>
        <div class="box-title-detail">
          <el-input
            v-if="isApplication"
            v-model="hobby"
            type="textarea"
            maxlength="200"
            :autosize="{ minRows: 4}"
            placeholder="请输入内容"
          />
          <span v-else>{{ applicationData && applicationData.hobbies }}</span>
        </div>
        <div class="box-title">
          课程情况
        </div>
        <div
          v-if="isApplication"
          content="choose-table-box"
        >
          <table>
            <tr>
              <td />
              <td>周一</td>
              <td>周二</td>
              <td>周三</td>
              <td>周四</td>
              <td>周五</td>
            </tr>
            <tr>
              <td>上午一二节</td>
              <td>
                <el-checkbox v-model="schedule.monday1" />
              </td>
              <td>
                <el-checkbox v-model="schedule.tuesday1" />
              </td>
              <td>
                <el-checkbox v-model="schedule.wednesday1" />
              </td>
              <td>
                <el-checkbox v-model="schedule.thursday1" />
              </td>
              <td>
                <el-checkbox v-model="schedule.friday1" />
              </td>
            </tr>
            <tr>
              <td>上午三四节</td>
              <td>
                <el-checkbox v-model="schedule.monday2" />
              </td>
              <td>
                <el-checkbox v-model="schedule.tuesday2" />
              </td>
              <td>
                <el-checkbox v-model="schedule.wednesday2" />
              </td>
              <td>
                <el-checkbox v-model="schedule.thursday2" />
              </td>
              <td>
                <el-checkbox v-model="schedule.friday2" />
              </td>
            </tr>
            <tr>
              <td>下午五六节</td>
              <td>
                <el-checkbox v-model="schedule.monday3" />
              </td>
              <td>
                <el-checkbox v-model="schedule.tuesday3" />
              </td>
              <td>
                <el-checkbox v-model="schedule.wednesday3" />
              </td>
              <td>
                <el-checkbox v-model="schedule.thursday3" />
              </td>
              <td>
                <el-checkbox v-model="schedule.friday3" />
              </td>
            </tr>
            <tr>
              <td>下午七八节</td>
              <td>
                <el-checkbox v-model="schedule.monday4" />
              </td>
              <td>
                <el-checkbox v-model="schedule.tuesday4" />
              </td>
              <td>
                <el-checkbox v-model="schedule.wednesday4" />
              </td>
              <td>
                <el-checkbox v-model="schedule.thursday4" />
              </td>
              <td>
                <el-checkbox v-model="schedule.friday4" />
              </td>
            </tr>
          </table>
        </div>
        <div
          v-else
          class="table-box"
        >
          <table>
            <tr>
              <td />
              <td>周一</td>
              <td>周二</td>
              <td>周三</td>
              <td>周四</td>
              <td>周五</td>
            </tr>
            <tr>
              <td>上午一二节</td>
              <td>{{ applicationData && applicationData.items.monday1 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.tuesday1 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.wednesday1 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.thursday1 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.friday1 ? '有课' : '' }}</td>
            </tr>
            <tr>
              <td>上午三四节</td>
              <td>{{ applicationData && applicationData.items.monday2 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.tuesday2 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.wednesday2 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.thursday2 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.friday2 ? '有课' : '' }}</td>
            </tr>
            <tr>
              <td>下午五六节</td>
              <td>{{ applicationData && applicationData.items.monday3 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.tuesday3 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.wednesday3 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.thursday3 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.friday3 ? '有课' : '' }}</td>
            </tr>
            <tr>
              <td>下午七八节</td>
              <td>{{ applicationData && applicationData.items.monday4 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.tuesday4 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.wednesday4 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.thursday4 ? '有课' : '' }}</td>
              <td>{{ applicationData && applicationData.items.friday4 ? '有课' : '' }}</td>
            </tr>
          </table>
        </div>
        <!--<div v-if="isntStu">-->
        <!--<div class="box-title" style="color: red">奖学金获得情况</div>-->
        <!--<div>一等奖</div>-->
        <!--</div>-->
        <div v-if="!isntStu">
          <div class="mt">
            历史资助情况：
          </div>
          <div class="mt">
            资助类
          </div>
          <div class="subsidyList">
            <el-table
              :data="infoObj && infoObj.subsidyList"
              style="width: 95%"
            >
              <el-table-column
                type="index"
                label="序号"
              />
              <el-table-column
                prop="typeName"
                label="资助类型"
              />
              <el-table-column
                prop="time"
                label="资助时间"
              />
              <el-table-column
                prop="moneyStr"
                label="资助金额"
              />
            </el-table>
          </div>
          <div class="mt">
            勤工助学类
          </div>
          <div class="subsidyList">
            <el-table
              :data="infoObj && infoObj.salaryList"
              style="width: 95%"
            >
              <el-table-column
                type="index"
                label="序号"
              />
              <el-table-column
                prop="jobName"
                label="岗位名称"
              />
              <el-table-column
                prop="yearMonthStr"
                label="工作时间"
              />
              <el-table-column
                prop="realMoney"
                label="已获得总报酬金额"
              />
            </el-table>
          </div>
        </div>
      </div>
      <span
        v-if="!applicationData"
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="handleClose">取 消</el-button>
        <el-button
          type="primary"
          @click="comfirmThis"
        >确 定</el-button>
      </span>

      <span
        v-if="applicationData&&interviewResult === 'PASS'"
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="comfirmModify"
        >确 认 修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserSn } from '@/auth/utils'
import moment from 'moment'

export default {
  name: 'ApplicationMaterials',
  props: {
    isntStu: Boolean,
    isApplication: Boolean,
    applicationData: Object,
    infoObj: Object,
    canInsert: Boolean,
    canApply: Boolean,
    interviewResult: String,
    subsidyList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      schedule: {
        monday1: false,
        tuesday1: false,
        wednesday1: false,
        thursday1: false,
        friday1: false,
        monday2: false,
        tuesday2: false,
        wednesday2: false,
        thursday2: false,
        friday2: false,
        monday3: false,
        tuesday3: false,
        wednesday3: false,
        thursday3: false,
        friday3: false,
        monday4: false,
        tuesday4: false,
        wednesday4: false,
        thursday4: false,
        friday4: false,
      },
      dialogVisible: false,
      bankName: '',
      bankNo: '',
      stuStuation: '', // 学习情况
      workStuation: '', // 工作情况
      economyStuation: '', // 经济情况
      unitKnown: '', // 岗位认识
      hobby: '', // 特长和爱好
      bankNameList: [],
    }
  },
  watch: {
    infoObj(newVal) {
      this.bankNo = newVal.bankNo
    },
  },
  created() {
    this.bankNo = this.infoObj.bankNo ? this.infoObj.bankNo : this.bankNo
  },
  methods: {
    handleSelect() {
      this.bankName = this.infoObj.bankName ? this.infoObj.bankName : this.bankName
    },
    querySearch(queryString, cb) {
      const a = []
      a.push({ value: this.infoObj.bankNo })
      cb(a)
    },
    getTime(timestamp) {
      if (timestamp === null || timestamp === 'null' || timestamp === undefined) {
        return ''
      }
      return moment(timestamp).format('YYYY-MM-DD')
    },
    // eslint-disable-next-line consistent-return
    comfirmThis() {
      if (!this.bankNo) {
        this.$message.warning('请填写银行账号')
        return false
      }
      if (this.bankName === '' || !this.bankName) {
        this.$message.warning('请填写开户银行')
        return false
      }
      if (this.stuStuation === '' || !this.stuStuation) {
        this.$message.warning('请填写学习情况')
        return false
      }
      if (this.workStuation === '') {
        this.$message.warning('请填写工作情况')
        return false
      }
      if (this.economyStuation === '') {
        this.$message.warning('请填写经济情况')
        return false
      }
      if (this.unitKnown === '') {
        this.$message.warning('请填写岗位认识')
        return false
      }
      if (this.hobby === '') {
        this.$message.warning('请填写特长和爱好')
        return false
      }
      // const querystring = require('querystring')
      const params = {
        work: this.workStuation,
        study: this.stuStuation,
        economic: this.economyStuation,
        cognition: this.unitKnown,
        schedule: JSON.stringify(this.schedule),
        hobbies: this.hobby,
        bank_name: this.bankName,
        bank_no: this.bankNo,
      }
      this.$emit('comfirmApplication', params)
    },
    // eslint-disable-next-line consistent-return
    comfirmModify() {
      if (this.bankNo === '') {
        this.$message.warning('请填写银行账号')
        return false
      }
      const params = {
        id: this.applicationData.id,
        sn: getUserSn(),
        bankNo: this.bankNo,
      }
      this.$emit('comfirmModify', params)
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
}
</script>

<style scoped lang="less">
    @import "../styles/var";

    /deep/ .el-dialog__footer {
        text-align: center;
    }

    .dialog-box {
        table {
            .table-style();
          width: 100%;
        }

        table td {
            .td-style();
            min-width: 90px;
        }

        // height: 500px;
        // overflow-y: auto;
        .info-box {
            .info-box-item {
                display: inline-block;
                font-size: 16px;
                margin-right: 250px;

                div {
                    margin-bottom: 20px;
                }
            }

            .info-box-item-right {
                .info-box-item;
                margin-right: 0;
            }
        }

        .box-title {
            color: #999;
            margin: 15px 0;
        }

        .warningD {
            color: @Warning;
        }

        .successD {
            color: @Success;
        }

        .subsidyList {
            margin-top: 20px;
        }

        .mt {
            margin-top: 15px;
        }
    }

    @media only screen and (max-width: 40em) {
      table td {
        min-width: 1px !important;
      }
    }
</style>
